'use client';

import CssBaseline from '@mui/material/CssBaseline';

import ProgressBar from '@/components/progress-bar';
import SnackbarProvider from '@/components/snackbar/snackbar-provider';
import NextLocalizationProvider from '@/i18n/localization-provider';
import ThemeProvider from '@/theme';

type Props = {
  children: React.ReactNode;
};

// Sits inside `GlobalProvider` rather than above it: `ThemeProvider` and `NextLocalizationProvider`
// read the settings and locale contexts it provides, and the snackbar styles read
// `theme.customShadows`, so notistack has to stay under the theme.
export const AppChrome = ({ children }: Props) => (
  <ThemeProvider>
    <CssBaseline enableColorScheme />
    <NextLocalizationProvider>
      <ProgressBar />
      <SnackbarProvider>{children}</SnackbarProvider>
    </NextLocalizationProvider>
  </ThemeProvider>
);
